import React, { useEffect, useState } from "react"
import {
  Accordion,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Tab,
  Tabs,
} from "react-bootstrap"

import * as yup from "yup"

import API from "../../common/API"

import Settings from "../../common/Settings"
import { parsedUser } from "../../common/GetCurrentUser"
import { useHistory, useParams } from "react-router-dom"
import { Routes } from "../../routes"
import { useTranslation } from "react-i18next"
const validationSchema = yup.object({
  name: yup.string().required("required"),
  latitude: yup.string().required(),
  longitude: yup.string().required(),
  image: yup.string().required(),
  categoryId: yup.string().required(),
  stageId: yup.string().required(),
})

const PlacePriority = props => {
  const [activeSheet, setActiveSheet] = useState("misLugares")
  const [isLoading, setIsLoading] = useState(false)
  const { t } = useTranslation()
  const user = parsedUser()
  const history = useHistory()
  const [recordsByMe, setRecordsByMe] = useState([])
  const [records, setRecords] = useState([])

  const requestData = async () => {
    let query = "&accountId=" + user.ID
    let requestAPI = await API.getAction("place/priorityList?" + query)
    if (requestAPI.data.status === "ok") {
      setRecords(requestAPI.data.response)
    }
  }
  const requestByMeData = async () => {
    let query = "&accountId=" + user.ID
    let requestAPI = await API.getAction(
      "place/PlacePriorityAssignedByMe?" + query
    )
    if (requestAPI.data.status === "ok") {
      setRecordsByMe(requestAPI.data.response)
    }
  }

  useEffect(() => {
    requestData()
  }, [])

  useEffect(() => {
    if (activeSheet === "misLugares") {
      requestData()
    } else {
      requestByMeData()
    }
  }, [activeSheet])
  return (
    <>
      <Modal
        show={props.show}
        onHide={props.toggle}
        size="lg"
        className="modalRight"
      >
        <Modal.Header closeButton>
          <Row className="mx-0 w-100">
            <Col>
              <h5>{t("Priority")}</h5>
            </Col>
          </Row>
        </Modal.Header>

        <Modal.Body className="p-0" style={{ overflow: "auto" }}>
          <Tabs
            defaultActiveKey={activeSheet}
            id="uncontrolled-tab-example"
            className="mb-3"
            activeKey={activeSheet}
            onSelect={key => {
              setActiveSheet(key)
            }}
          >
            <Tab eventKey="misLugares" title="Mis lugares">
              {records &&
                records.map((record, index) => {
                  let item = record.place
                  return (
                    <div className="card shadow-sm my-4 mx-2" key={index}>
                      <div
                        className="card-body p-1 clickable"
                        onClick={() => {
                          history.push(Routes.PlaceDetails.clean + item.id)
                        }}
                      >
                        <div className="row mx-0">
                          <div className="col-3">
                            <img
                              className="img-fluid"
                              style={{
                                height: 100,
                                width: 100,
                                objectFit: "cover",
                              }}
                              src={`${Settings.BasePath}file/getThumbnail?filename=${item.image}`}
                              alt={item.name}
                              onClick={() => {
                                console.log(item)
                              }}
                            ></img>
                          </div>
                          <div className="col-9">
                            <div className="row">
                              <div className="col">
                                <b>{item.name}</b>
                              </div>
                              <div className="col text-end">
                                <i className={item.stage.icon} />
                                {item.visits && (
                                  <span
                                    className={
                                      "badge  ms-2 py-1 " +
                                      (item.visits === 0
                                        ? "bg-danger"
                                        : "bg-info")
                                    }
                                  >
                                    {t("Visits")}: {item.visits}
                                  </span>
                                )}
                              </div>
                            </div>
                            <p className="card-text text-wrap">
                              {`${item.address ?? ""}, ${item.sector ?? ""}, ${
                                item.city ?? ""
                              }, ${item.region ?? ""}, ${item.country}`}
                            </p>
                            <p>
                              {item.assignedTo && (
                                <span className={""}>
                                  {t("Assigned to")}:{" "}
                                  {item.assignedTo.firstName}{" "}
                                  {item.assignedTo.lastName}
                                </span>
                              )}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer">
                        <button
                          className="btn btn-success btn-sm"
                          type="button"
                          onClick={() => {
                            let fullAddress = ""
                            fullAddress = `${item.latitude},${item.longitude}`
                            //`${model.item.streetAddress ?? ""}, ${model.item.city ?? ""}, ${model.item.state ?? ""}, ${model.item.country}`;
                            window.open(
                              `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
                              "MapWindow",
                              "width=1280,height=840"
                            )
                          }}
                        >
                          {t("Get Directions")}
                        </button>
                      </div>
                    </div>
                  )
                })}
            </Tab>
            <Tab eventKey="profile" title="Asignados por mi">
              <Accordion defaultActiveKey="0">
                {recordsByMe &&
                  recordsByMe.map((record, index) => {
                    return (
                      <Accordion.Item eventKey={index} key={index}>
                        <Accordion.Header>
                          {record.account.firstName} {record.account.lastName} (
                          {record.places.length})
                        </Accordion.Header>
                        <Accordion.Body>
                          {record.places &&
                            record.places.map((item, index) => {
                              return (
                                <div
                                  className="card shadow-sm my-4 mx-2"
                                  key={index}
                                >
                                  <div
                                    className="card-body p-1 clickable"
                                    onClick={() => {
                                      history.push(
                                        Routes.PlaceDetails.clean + item.id
                                      )
                                    }}
                                  >
                                    <div className="row mx-0">
                                      <div className="col-3">
                                        <img
                                          className="img-fluid"
                                          style={{
                                            height: 100,
                                            width: 100,
                                            objectFit: "cover",
                                          }}
                                          src={`${Settings.BasePath}file/getThumbnail?filename=${item.image}`}
                                          alt={item.name}
                                          onClick={() => {
                                            console.log(item)
                                          }}
                                        ></img>
                                      </div>
                                      <div className="col-9">
                                        <div className="row">
                                          <div className="col">
                                            <b>{item.name}</b>
                                          </div>
                                          <div className="col text-end">
                                            <i className={item.stage.icon} />
                                            {item.visits && (
                                              <span
                                                className={
                                                  "badge  ms-2 py-1 " +
                                                  (item.visits === 0
                                                    ? "bg-danger"
                                                    : "bg-info")
                                                }
                                              >
                                                {t("Visits")}: {item.visits}
                                              </span>
                                            )}
                                          </div>
                                        </div>
                                        <p className="card-text text-wrap">
                                          {`${item.address ?? ""}, ${
                                            item.sector ?? ""
                                          }, ${item.city ?? ""}, ${
                                            item.region ?? ""
                                          }, ${item.country}`}
                                        </p>
                                        <p>
                                          {item.assignedTo && (
                                            <span className={""}>
                                              {t("Assigned to")}:{" "}
                                              {item.assignedTo.firstName}{" "}
                                              {item.assignedTo.lastName}
                                            </span>
                                          )}
                                        </p>
                                      </div>
                                    </div>
                                  </div>

                                  <div className="card-footer">
                                    <button
                                      className="btn btn-success btn-sm"
                                      type="button"
                                      onClick={() => {
                                        let fullAddress = ""
                                        fullAddress = `${item.latitude},${item.longitude}`
                                        //`${model.item.streetAddress ?? ""}, ${model.item.city ?? ""}, ${model.item.state ?? ""}, ${model.item.country}`;
                                        window.open(
                                          `https://www.google.com/maps/search/?api=1&query=${fullAddress}`,
                                          "MapWindow",
                                          "width=1280,height=840"
                                        )
                                      }}
                                    >
                                      {t("Get Directions")}
                                    </button>
                                  </div>
                                </div>
                              )
                            })}
                        </Accordion.Body>
                      </Accordion.Item>
                    )
                  })}
              </Accordion>
            </Tab>
          </Tabs>
        </Modal.Body>
      </Modal>
    </>
  )
}

export default PlacePriority
